import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Notice, Pager } from "../../lib/ui";

/*
 * Stock list – port of addStock.php / AddPayment.php + stock_ajax.php (API: GET /api/stock/products, backend/recon.py)
 * Search (name, manufacturer, type), sortable columns, 10 per page.
 */

const COLS = [["product_id", "ID", true], ["product_name", "Product", false], ["manufacturer", "Manufacturer", false], ["product_type", "Type", false],
  ["expiry_date", "Expiry date", false], ["purchase_price", "Purchase price", true], ["sales_price", "Sales price", true], ["quantity", "Quantity", true]];

export default function StockList({ slug = "addStock" }) {
  const api = useApi();
  const [q, setQ] = useState({ page: 1, sort: "product_id", order: "ASC", search: "" });
  const [term, setTerm] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async (p) => { try { setData(await api.get("/api/stock/products", p)); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(q); }, [load, q]);
  useEffect(() => { const t = setTimeout(() => setQ((s) => (s.search === term ? s : { ...s, search: term, page: 1 })), 300); return () => clearTimeout(t); }, [term]);
  const sortBy = (k) => setQ((s) => ({ ...s, sort: k, order: s.sort === k && s.order === "ASC" ? "DESC" : "ASC", page: 1 }));
  const expired = (d) => d && d < new Date().toISOString().slice(0, 10);

  return (
    <main className="pg" style={{ maxWidth: "88rem" }}>
      <PageHeader slug={slug} actions={<Link to="/productAdd" className="btn primary"><i className="fas fa-plus" /> Add new product</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">
        <div className="toolbar"><div className="field grow"><div className="search"><i className="fas fa-magnifying-glass" />
          <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search by name, type or manufacturer" aria-label="Search products" /></div></div>
          {data && <span style={{ alignSelf: "center", fontSize: ".8125rem", color: "var(--muted)" }}>{data.total} products</span>}</div>
        <div className="tbl-wrap">
          <table className="tbl">
            <thead><tr>{COLS.map(([k, label, num]) => (
              <th key={k} className={`sortable ${num ? "num" : ""}`} onClick={() => sortBy(k)} aria-sort={q.sort === k ? (q.order === "ASC" ? "ascending" : "descending") : "none"}>
                {label} {q.sort === k && <i className={`fas ${q.order === "ASC" ? "fa-sort-up" : "fa-sort-down"}`} />}</th>))}</tr></thead>
            <tbody>
              {data?.rows.map((r) => (
                <tr key={r.product_id}>
                  <td className="num mono">{r.product_id}</td><td style={{ fontWeight: 600, color: "var(--ink)" }}>{r.product_name}</td>
                  <td>{r.manufacturer}</td><td>{r.product_type}</td>
                  <td style={expired(r.expiry_date) ? { color: "var(--danger)", fontWeight: 600 } : undefined}>{r.expiry_date || "–"}</td>
                  <td className="num mono">{n2(r.purchase_price)}</td><td className="num mono">{n2(r.sales_price)}</td>
                  <td className="num mono">{r.quantity} <small style={{ color: "var(--muted)" }}>{r.unit_of_measurement}</small></td>
                </tr>
              ))}
            </tbody>
          </table>
          {data && data.rows.length === 0 && <div className="empty"><i className="fas fa-box-open" />No products found.</div>}
        </div>
        {data && <Pager page={data.page} totalPages={data.pages} onPage={(p) => setQ({ ...q, page: p })} />}
      </section>
    </main>
  );
}
